'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCamera = function TiCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 10h-2.7l-1.6-1.7c-1-0.9-2.7-1.6-4.1-1.6h-6.6c-1.4 0-3.1 0.7-4.1 1.6l-1.6 1.7h-2.7c-2.7 0-5 2.2-5 5v13.3c0 2.8 2.3 5 5 5h23.4c2.7 0 5-2.2 5-5v-13.3c0-2.8-2.3-5-5-5z m-11.7 16.7c-3.2 0-5.8-2.6-5.8-5.9 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 3.3-2.6 5.9-5.8 5.9z m10-7.9c-1.2 0-2.2-0.9-2.2-2.1s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.1-2.2 2.1z' })
        )
    );
};

exports.default = TiCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/camera.js
// module id = 3021
// module chunks = 0